import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../modules';

import { selectContent } from '../../modules/editor';

import ErrorBoundary from '../../components/ErrorBoundary';
import Alert from '../../lib/Alert';
import SelectedContentBase from './SelectedContentBase';
import SelectedContentDonation from './SelectedContentDonation';
import SelectedContentFooter from './SelectedContentFooter';
import SelectedContentHeader from './SelectedContentHeader';
import SelectedContentHtmlcode from './SelectedContentHtmlcode';
import SelectedContentMap from './SelectedContentMap';
import SelectedContentNaverAd from './SelectedContentNaverAd';
import SelectedContentPartition from './SelectedContentPartition';
import SelectedContentPermalink from './SelectedContentPermalink';
import SelectedContentShare from './SelectedContentShare';
import SelectedContentShop from './SelectedContentShop';
import SelectedContentSns from './SelectedContentSns';
import SelectedContentSpacer from './SelectedContentSpacer';
import SelectedContentStyle from './SelectedContentStyle';
import SelectedContentVideo from './SelectedContentVideo';

function SelectedContent({ showSelectedSidebar }) {
	const dispatch = useDispatch();

	const selectedContentId = useSelector((state: RootState) => state.editor.selectedContentId);
	const contents = useSelector((state: RootState) => state.editor.contents);
	const { templateId } = useSelector((state: RootState) => state.editor.email);

	const currentContent = contents?.find((item) => {
		return item.id === selectedContentId;
	});

	let styleTarget = `${selectedContentId}/style/0`;
	let currentContentStyle:any = currentContent?.content?.style?.[0];

	if (Array.isArray(currentContentStyle)) {
		currentContentStyle = currentContent?.content?.style?.[0]?.[0];
		styleTarget = `${selectedContentId}/style/0/0`;
	}

	const settingPanels:any = {
		base: SelectedContentBase,
		permalink: SelectedContentPermalink,
		header: SelectedContentHeader,
		footer: SelectedContentFooter,
		map: SelectedContentMap,
		video: SelectedContentVideo,
		sns: SelectedContentSns,
		share: SelectedContentShare,
		donation: SelectedContentDonation,
		shop: SelectedContentShop,
		htmlcode: SelectedContentHtmlcode,
		partition: SelectedContentPartition,
		spacer: SelectedContentSpacer,
		'naver-ad': SelectedContentNaverAd
	}
	const currentCategory:string|undefined = currentContent?.content?.category;
	const SettingPanel = currentCategory ? settingPanels[currentCategory] : SelectedContentBase;

	const close = () => {
		dispatch(selectContent(-1));
	}

	const msg = useSelector((store) => store.editor.service.msg);
	const onInvalidBlockError = () => {
		Alert.error(msg.DEFAULT_ERROR);
		close();
	}

	return (
		<div className={!showSelectedSidebar ? 'editor-sidebar-selected-content' : 'editor-sidebar-selected-content active'}>
			<header className="selected-content-header">
				<h2>{currentContent?.content?.typeText}</h2>
				<button className="btn medium" onClick={close}>닫기</button>
			</header>

			<ErrorBoundary fallback={<></>} onError={onInvalidBlockError} resetKeys={[currentContent]}>
				<SettingPanel
					selectedContentId={selectedContentId}
					currentContent={currentContent}
				/>

				<SelectedContentStyle
					currentContent={currentContent}
					styleTarget={styleTarget}
					currentContentStyle={currentContentStyle}
				/>
			</ErrorBoundary>
		</div>
	);
}

export default SelectedContent;